/* eslint-disable array-callback-return */
import * as S from "./styles";

const EnvironmentMessage = () => {
  return (
    <S.Container>
      <p>
        Esse é um ambiente de testes e demonstração, algumas instabilidades
        poderão ser encontradas.
      </p>
    </S.Container>
  );
};

export default EnvironmentMessage;
